
import {defineComponent, inject, nextTick, onMounted, reactive, ref, watch} from "vue";
import {useRoute, useRouter} from "vue-router";
import {Debounce} from "../../api/api";
import {incomeListByDay} from "../../api/http";
import {Request} from "../../api/request";
import {column} from "@/assets/types/common";

const columnList: Array<column> = [
    {
        prop: "income_type_mytext",
        label: "收入类型",
        width: 80,
    },
    {
        prop: "order_sn",
        label: "关联单据",
        width: 80,
    },
    {
        prop: "create_time_text",
        label: "创建时间",
        width: 80,
    },
    {
        prop: "status_text",
        label: "状态",
        width: 80,
    },
    {
        prop: "income_price",
        label: "金额",
        width: 80,
    },
    {
        prop: "income_collection_mytext",
        label: "收款方式",
        width: 80,
    },
    {
        prop: "income_payer",
        label: "付款方",
        width: 80,
    },
    {
        prop: "admin",
        label: "经手人",
        width: 80,
    },
    {
        prop: "income_desc",
        label: "备注",
        width: 80,
    },
];
export default defineComponent({
    name: "incomeListByDay",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(["收入列表"]);
        const headClass = inject("headClass");
        const Router = useRouter();
        let pageSize = ref(10),
            currentPage = ref(1),
            loading = ref(false),
            total = ref(0),
            total_price = ref(0),
            detailTable = ref([] as Array<any>),
            tableData = ref([] as Array<any>),
            dialog_model = ref(false),
            currentDate ='' as any,
            pay_type = '' as any;
        let handleSizeChange = (pagesize: number): void => {
                pageSize.value = pagesize;
                getTableData();
            },
            handleCurrentChange = (page: number): void => {
                currentPage.value = page;
                getTableData();
            },
            getTableData = () => {
                loading.value = true;
                let data = {
                    date_time: currentDate,
                    pay_type: pay_type,
                    page:currentPage.value,
                    pagesize:pageSize.value
                }
                incomeListByDay(data).then((res:any) => {
                    tableData.value = res?.content?.list || [];
                    loading.value = false;
                    total.value = res?.content?.total || 0;
                    total_price.value = res?.content?.total_price || 0;
                });
            },
            getSummaries = (param: any): Array<string> => {
                const {columns, data} = param;
                const sums: any = [];
                const propArr = [
                    "income_price"
                ];
                columns.forEach((column: any, index: number) => {
                    if (index === 0) {
                        sums[index] = "合计";
                        return;
                    }
                    const values = data.map((item: any) =>
                        Number(item[column.property])
                    );
                    if (
                        propArr.findIndex((item: any) => {
                            return item == column.property;
                        }) > -1
                    ) {
                        // 增加合计项
                        if (column.property == "income_price") {
                            sums[index] = total_price.value;
                        }
                    } else {
                        sums[index] = "";
                    }
                });
                return sums;
            },
            detailClick = (index:number)=> {
                dialog_model.value = true;
                //dialog_index = index;
                let arr = [[
                    '收入日期',
                    tableData.value[index].income_time_text,
                    '收入类型',
                    tableData.value[index].income_type_mytext,
                    '类别',
                    tableData.value[index].expenditure_type,
                    '关联单据',
                    tableData.value[index].order_sn,
                ],[
                    '创建时间',
                    tableData.value[index].create_time_text,
                    '创建人',
                    tableData.value[index].admin,
                    '状态',
                    tableData.value[index].toexamine,
                    '审核时间',
                    tableData.value[index].audit_time,
                ],[
                    '审核人',
                    tableData.value[index].admin,
                    '金额',
                    tableData.value[index].income_price,
                    '收款方式',
                    tableData.value[index].income_collection_mytext,
                    '付款方',
                    tableData.value[index].income_payer,
                ],[
                    '联系电话',
                    tableData.value[index].income_phone,
                    '经手人',
                    tableData.value[index].admin,
                    '备注',
                    tableData.value[index].income_desc,
                ]];
                detailTable.value = arr;
            },
            getIncomeDetail = (()=>{
            
            });
        onMounted(() => {
            currentDate = useRoute().query.time;
            pay_type = useRoute().query.pay_type;
            getTableData();
        });
        
        return {
            columnList,
            
            loading,
            total,
            tableData,
            pageSize,
            currentPage,
            dialog_model,
            detailTable,
            
            getIncomeDetail,
            handleCurrentChange,
            handleSizeChange,
            getTableData,
            detailClick,
            getSummaries,
            total_price
        };
    },
});

